// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "header strong{margin-left:6px}header .nav .nuxt-link-active,header .nav .nuxt-link-active+svg{position:relative;--text-opacity:1;color:#009d7f;color:rgba(0,157,127,var(--text-opacity))}header .hamb span{width:18px;height:2px;display:block;--bg-opacity:1;background-color:#212124;background-color:rgba(33,33,36,var(--bg-opacity));border-radius:.375rem}header .hamb span:nth-child(2){margin-top:.25rem;margin-bottom:.25rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
